module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_6005.75e72590.png";